<template>

    <div>

        <!-- page-heading -->
        <page-heading :show="true" pageTitle="IP-HEADLINE"></page-heading>

        <!-- show loading indicator -->
        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <div class="columns">

                <div class="col-main">


                    <!-- filter default: path="mediaArchive"; -->


                    <v-client-table ref="tblImagePool" name="tblImagePool" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tbl-imagePool noFirstColumn">

                        <template slot="h__select">
                            <p-check name="check" color="primary" class="p-default p-curve p-smooth" v-model="allMarked" @click.prevent.native="toggleAll()"></p-check>
                            <!-- <input type="checkbox" @click="toggleAll()" class="is-pointer" /> -->
                        </template>


                        <!-- before table: FILTER OPTIONS -->
                        <template slot="beforeTable">

                            <div class="columns filters">

                                <!-- SEARCH -->
                                <div class="control has-icon search is-pulled-left" style="margin-right: 7px;">
                                    <input class="input" type="text" ref="checkboxSelector" v-model="searchString" placeholder="Suchbegriff">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </div>

                                <!-- SELECT BOX FILTER ARTICLES -->
                                <form-input label="IP-FILTER_ARTICLES" maxWidth="250px" :showLabel="false" inputType="select" selectFieldName="title" :showLabelInOptions="false" :selectOptions="articles" v-model="articleSelected" :is-horizontal="true"></form-input>

                                <div class="control" style="margin-left: 15px; display: flex; justify-content: center; align-items: center;">
                                    <div style="margin-right: 5px;">Medienarchiv</div>
                                    <p-check class="p-switch p-smooth" color="primary" v-model="mediaArchiveActive" toggle="true">
                                        <label slot="off-label"></label>
                                    </p-check>
                                </div>

                            </div>


                        </template>


                      <!-- checkbox -->
                      <template slot="select" slot-scope="props">
                    		<div class="checkboxWrapper">
                          <p-check name="check" color="primary" :value="props.row.id" v-model="markedRows" class="p-default p-curve p-smooth"></p-check>
                        </div>
                    	</template>

                      <!-- picture -->
            					<template slot="picture" slot-scope="props">
			                  <div class="imgWrapper lazy-img-fadein" v-bind:style="{ 'background-image': 'url(' + props.row._thumb.src + ')' }"></div>
            					</template>

                      <!-- description -->
            					<template slot="description" slot-scope="props">

        			          <!-- <span class="has-text-light">{{ props.row.filename }}</span><br /> -->
                        <span v-html="props.row.caption"></span>

                        <div class="options" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
                            <a class="button is-small" @click.prevent.stop="deleteImage(props.row.id)">
                                <span class="icon is-small">
                                    <i class="fa icon-ak-entfernen"></i>
                                </span>
                                <span>Bild entfernen</span>
                            </a>
                        </div>

            					</template>

                      <!-- linked articles -->
            					<template slot="linked" slot-scope="props">

                        <template v-if="props.row.articles">

                            <popover title="Verknüpfte Artikel" trigger="hover" :disabled="props.row.articles.length == 0">
                                <div slot="content" class="small" v-html="getPopoverContent(props.row.articles)"></div>
                                <span class="button is-light is-small">{{ props.row.articles.length }}</span>
                            </popover>

                        </template>

                        <template v-else>
                            --
                        </template>

                      </template>

                      <!-- last updated -->
            					<template slot="updated" slot-scope="props">
			                  {{ lastUpdated(props) }}
            					</template>


                      <template slot="afterTable">

                          <span :class="['button is-light', { 'is-disabled': markedRows.length == 0 }]" @click="massEditImagesDelete" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
                              <span class="icon is-small"><i class="icon-ak-entfernen"></i></span>Auswahl löschen
                          </span>

                          <span :class="['button is-light', { 'is-disabled': markedRows.length == 0 }]" @click="massEditImagesEdit" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Agentur Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
                              <span class="icon is-small"><i class="icon-ak-bearbeiten"></i></span>Auswahl bearbeiten
                          </span>

                      </template>

                    </v-client-table>

                </div>

                <div class="col-aside">

        			<affix :offset="50">

      					<custom-button type="blue" name="IP-BTN-IMAGE_ADD" icon="icon-ak-hinzufuegen" @click.native="uploadImages" :disabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Agentur Chefredaktion', 'Autor'].indexOf(activeUser.userRole.name) == -1"></custom-button>

                <router-link :to="{ name: 'complatImagePoolChangelog' }" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
                    <custom-button type="dark" name="IP-BTN-CHANGELOG" icon="icon-ak-history"></custom-button>
                </router-link>

        			</affix>

        		</div>

            </div>


            <!-- MODAL WINDOW -->
            <modal
        			:title="modal.title"
        			transition="zoom"
        			cancel-text="abbrechen"
        			:show-ok="false"
        			:backdrop-closable="false"
        			:is-show="showModal"
        			@close="closeModal"
        			:class="modal.class">

                    <!-- EDIT IMAGES -->
                    <template v-if="modal.type=='edit'">

                        <template v-if="!modal.isLoading">

                            <div style="width: 80%; min-width: 480px; margin: 0 auto">

                                <!-- status -->
                                <form-input inputType="select" label="IP-STATUS" v-model="selectedImages.status" :selectOptions="assetStatus"></form-input>

                                <!-- quelle -->
                                <form-input inputType="text" label="IP-ORIGIN" v-model="selectedImages.origin" placeholder="Quelle angeben (optional)" :isHorizontal="false"></form-input>

                                <!-- verknüpfungen (articles)-->
                                <div class="control">

                                    <div class="control-label">
                                        <label-name labelKey="IP-ARTICLES"></label-name>
                                    </div>

                                    <div class="control">

                                        <multiselect
                                            v-model="selectedImages.articles"
                                            :options="articles"
                                            label="name"
                                            deselect-label="Klick um abzuwählen"
                                            selectLabel="Klick um auszuwählen"
                                            selectedLabel="ausgewählt"
                                            :customLabel="customLabel"
                                            :placeholder="$t('SELECT_BOX-IP-ARTICLES-PLEASE_SELECT')"
                                            :multiple="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :preserve-search="false"
                                            track-by="id"
                                            class="singleSelect">

                                        </multiselect>

                                    </div>
                                </div>


                            </div>

                            <div slot="footer">
                                <span class="button" @click="closeModal">schließen</span>
                                <span :class="['button is-success', { 'is-loading': modalIsSaving }]" @click="massEditImagesOk">speichern</span>
                            </div>

                        </template>

                        <template v-else>
                            <loading-indicator></loading-indicator>
                        </template>

                    </template>


                    <!-- UPLOAD IMAGES -->
                    <template v-if="modal.type=='upload'">

                        <div slot="header">
                            <div class="modal-card-title" style="display: inline-block; margin-right: 10px;">{{ modal.title }}</div><span>(Max. 50 Bilder pro Upload)</span>
                        </div>

                        <vue-dropzone
                            ref="dzImagePool"
                            id="dzImagePool"
                            url="fileProcessing/upload?preset=article"
                            :maxFiles="50"
                            :thumbnailWidth="100"
                            :thumbnailHeight="100"
                            acceptedFiles= ".jpg,.jpeg,.png,.gif"
                            dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Bild hochladen"
                            v-on:vdropzone-success="dzSuccess">
                        </vue-dropzone>


                        <template v-if="uploadedImages.length > 0">

                            <div style="width: 80%; min-width: 480px; margin: 5px auto">

                                <!-- quelle -->
                                <form-input inputType="text" label="IP-ORIGIN" v-model="selectedImages.origin" placeholder="Quelle angeben (optional)" :isHorizontal="false"></form-input>

                                <!-- verknüpfungen (articles)-->
                                <div class="control">

                                    <div class="control-label">
                                        <label-name labelKey="IP-ARTICLES"></label-name>
                                    </div>

                                    <div class="control">

                                        <multiselect
                                            v-model="selectedImages.articles"
                                            :options="articles"
                                            label="name"
                                            deselect-label="Klick um abzuwählen"
                                            selectLabel="Klick um auszuwählen"
                                            selectedLabel="ausgewählt"
                                            :customLabel="customLabel"
                                            :placeholder="$t('SELECT_BOX-IP-ARTICLES-PLEASE_SELECT')"
                                            :multiple="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :preserve-search="false"
                                            track-by="id"
                                            class="singleSelect">

                                        </multiselect>

                                    </div>
                                </div>

                            </div>

                        </template>

                        <div class="uploadedImagesContainer">

                            <div class="columns uploadedImages" v-for="(image, index) in uploadedImages">

                                <div class="column">
                                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(image)"></div>
                                </div>
                                <div class="column">
                                    {{ image.filename }}<br />
                                </div>

                                <div class="column">

                                    <router-link :to="{ name: 'complatImagePoolImage', params: { imageID: image.id } }">
                                        <span class="icon is-small">
                                            <i class="icon-ak-bearbeiten"></i>
                                        </span>
                                    </router-link>

                                </div>
                            </div>

                        </div>

                        <div slot="footer">
                            <span class="button" @click="closeModal">schließen</span>
                            <template v-if="uploadedImages.length > 0">
                                <span :class="['button is-success', { 'is-loading': modalIsSaving }]" @click="uploadedImagesOK">speichern</span>
                            </template>
                        </div>

                    </template>

            </modal>

        </template>

    </div>



</template>


<script>
import Vue from 'vue';

import vue2Dropzone from '../../utils/dropzoneWrapper'
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

export default {

    components: {
		    vueDropzone: vue2Dropzone,
    },

    data() {

        var self = this;

        return {

            isLoading: false,
            showModal: false,
            searchString: "",
            allMarked: false,
            markedRows: [],
            uploadedImages: [],

            articles: [],
            articleSelected: '',
            selectedImages: {
                origin: null,
                status: null,
                articles: [],
            },

            mediaArchiveActive: false,

            modal: {
                type: null,
                title: "",
                class: "",
                isLoading: false
            },

            modalIsSaving: false,

            table: {
                tblColumns: ['select', 'picture', 'description', 'origin', 'linked', 'updated'],
                tblData: [],
                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 10,
                    orderBy: {
                        ascending: false,
                        column: 'updated'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {
                        picture(h) {
                            return <lang labelKey="IP-TBL_HEADER-IMAGE"></lang>
                        },
                        description(h) {
                            return <lang labelKey="IP-TBL_HEADER-DESCRIPTION"></lang>
                        },
                        origin(h) {
                            return <lang labelKey="IP-TBL_HEADER-ORIGIN"></lang>
                        },
                        linked(h) {
                            return <lang labelKey="IP-TBL_HEADER-LINKED"></lang>
                        },
                        updated(h) {
                            return <lang labelKey="IP-TBL_HEADER-LAST_UPDATED"></lang>
                        },
                    },
                    sortable: ['updated', 'linked'],
                    descOrderColumns: ['updated'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,
                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },
                    columnsClasses: {
                        'select': 'firstCol'
                    },
                    pagination: {
                        chunk: 5
                    },
                    skin: 'table is-striped is-hoverable is-fullwidth',


                    initFilters: {
                        isArchive: '0'
                    },


                    // custom filter functions
                    customFilters: [
                        {
                          name: 'search',
		                        callback(row, string) {
                							if(string == null || string == "") {
                								return true;
                							}
                              string = string.toLowerCase();
                              return row._search.indexOf(string) > -1

                              /*
                              return
                              row.filename != null && row.filename.toLowerCase().indexOf(string) > -1
                              || row.caption != null && row.caption.toLowerCase().indexOf(string) > -1
                              || row.tags != null && row.tags.toLowerCase().indexOf(string) > -1
                              || row.altText != null && row.altText.toLowerCase().indexOf(string) > -1;
                              */

        						        }
                        },

                        {
                        name: 'filterArticles',
                            callback(row, string) {
                                if(string == null || string == "") {
                                    return true;
                                }
                                if(row.articles.length == 0) {
                                    return false;
                                }
                                return row.articles.findIndex(_ => _.id == string.id) > -1;
                            }
                        },
                        {
                            name: 'isArchive',
                            callback(row, isArchive) {
                                return isArchive == '1' ? true : row.path != 'mediaArchive';
                            }
                        }

                    ],
                    // custom sorting functions
                    customSorting: {

                      linked: function(ascending) {
                        return function (a, b) {
                          return self.sort(a.articles.length, b.articles.length, ascending);
                        }
                      },

                    },

          					rowClassCallback: function(row) {

          						if(row.status == null) {
          							return '';
          						}

                      return row.status;

          					}

                }

            }
        }
    },

    computed: {

  		assetStatus() {
  			return this.$store.getters.getTermsByTaxonomy('ASSET_STATUS');
  		},

    },


    watch: {

        searchString(newVal, oldVal) {

            if(newVal == oldVal) {
                return;
            }

            setTimeout(() => {
                Event.$emit('vue-tables.tblImagePool.filter::search', this.searchString );
            }, 10);

        },

        mediaArchiveActive(newVal) {

            setTimeout(() => {
                Event.$emit('vue-tables.tblImagePool.filter::isArchive', newVal ? "1" : "0" );
            }, 5);

        },

        articleSelected(newVal, oldVal) {

            setTimeout(() => {
                Event.$emit('vue-tables.tblImagePool.filter::filterArticles', newVal );
            }, 10);

        },

        markedRows(newVal, oldVal) {
            if(this.markedRows.length != this.table.tblData.length) {
                this.allMarked = false;
            }
        }

    },

  created() {

    this.fetchData();

	},


	mounted() {

    	Event.$on('vue-tables.tblImagePool.row-click', function (data) {

            if(['checkboxWrapper', 'checkbox', 'firstCol'].indexOf(data.event.target.className) > -1 || ['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                return false;
            }

		    this.$router.push({ name: 'complatImagePoolImage', params: { 'imageID': data.row.id }  });

    	}.bind(this));

	},

    methods: {

        sort(a, b, ascending) {

			if (typeof a === 'string') {
				a = a.toLowerCase();
				a = a.replace("ä", "ae");
				a = a.replace("ö", "oe");
				a = a.replace("ü", "ue");
			}

			if (typeof b === 'string') {
				 b = b.toLowerCase();
				 b = b.replace("ä", "ae");
				 b = b.replace("ö", "oe");
				 b = b.replace("ü", "ue");
			}

			if(ascending) {
				return a <= b ? 1 : -1;
			}

			return a >= b ? 1 : -1;

		},

        getPopoverContent(articles) {

            var articleArr = [];

            articles.forEach(function(article) {

                if(article.article) {
                    articleArr.push("- " + article.article.title);
                }
                else if(article.title) {
                    articleArr.push("- " + article.title);
                }
                else {
                    articleArr.push("-");
                }
            })

            return articleArr.join('<br />');

        },

        customLabel ({ title, desc }) {

            return title;

        },

        lastUpdated(props) {

            if(typeof props.row.updated == 'undefined') {
                return "--";
            }
            return this.formatDate2(props.row.updated)

        },

        massEditImagesEdit() {

            this.showModal = true;
            this.modal.title = 'Bilder Massenbearbeitung';
            this.modal.type = 'edit';
            this.modal.class = "modalEditImages";
            this.modal.isLoading = false;

        },

        massEditImagesOk() {

            var self = this;

            this.modalIsSaving = true;

            var articleAssets = {
                assets: [],
                articles: []
            };

            // add selected articles to articleAssets.articles[]
            this.selectedImages.articles.forEach(article => {

                if(articleAssets.articles.indexOf(article.id) == -1) {
                    articleAssets.articles.push(article.id);
                }

            })

            let images  = this.table.tblData.filter(img => {
                return self.markedRows.indexOf(img.id) > -1;
            })


            images.forEach(img => {

                if(self.selectedImages.origin != "") {
                    img.origin = self.selectedImages.origin;
                }

                if(self.selectedImages.status != null) {
                    img.status = self.selectedImages.status;
                }

                if(self.selectedImages.articles.length > 0) {

                    // add the image id to articleAssets.assets[]
                    articleAssets.assets.push(img.id);

                    // make sure to also add existing articles of an image to articleAssets.articles[]
                    img.articles.forEach(imgArticle => {

                        if(articleAssets.articles.indexOf(imgArticle.id) == -1) {
                            articleAssets.articles.push(imgArticle.id);
                        }

                    })

                }

            })


            /*
            var articleAssets = {
                assets: [],
                articles: []
            };

            this.table.tblData.forEach(image => {

                if(self.markedRows.indexOf(image.id) > -1) {

                    if(self.selectedImages.origin != "") {
                        image.origin = self.selectedImages.origin;
                    }

                    if(self.selectedImages.status != null) {
                        image.status = self.selectedImages.status;
                    }

                    if(self.selectedImages.articles.length > 0) {

                        articleAssets.assets.push(image.id);

                        self.selectedImages.articles.forEach(function(article) {
                            if(articleAssets.articles.indexOf(article.id) == -1) {
                                articleAssets.articles.push(article.id);
                            }
                        })
                    }

                }

            })
            */


            // save
            self.entityCreateOrUpdate('asset', images, { isSilent: true }).then(response => {

                    if(articleAssets.articles.length > 0) {

                        self.axios.put(self.$config.api + 'articleAsset/updateArticleReferences', articleAssets)
                            .then(response => {

                                self.modalIsSaving = false;
                                self.showModal = false;

                                // reset marked rows
                                self.markedRows = [];

                                // reset fields
                                self.selectedImages.origin = "";
                                self.selectedImages.status = null;
                                self.selectedImages.articles = [];


                                articleAssets.assets.forEach(AAsset => {

                                    self.table.tblData.forEach(asset => {
                                        if(asset.id == AAsset) {
                                            asset.articles = response.data.article;
                                        }
                                    })

                                })

                            });

                    } else {

                        // reset marked rows
                        self.markedRows = [];

                        // reset fields
                        self.selectedImages.origin = "";
                        self.selectedImages.status = null;
                        self.selectedImages.articles = [];

                        self.modalIsSaving = false;
                        self.showModal = false;

                    }


                })

        },

        uploadedImagesOK() {

            this.modalIsSaving = true;

            var articleAssets = [];

            this.uploadedImages.forEach((image) => {

                if(this.selectedImages.origin != "") {
                    image.origin = this.selectedImages.origin;
                }

                if(this.selectedImages.articles.length > 0) {
                    image.articles = [];
                    this.selectedImages.articles.forEach(function(article) {
                        articleAssets.push({
                            asset: image.id,
                            article: article.id,
                            isDefault: false
                        });
                    })
                }

            })

            // save
            this.save(false)
                .then((response) => {

                    console.log(response);
                    this.table.tblData.push(response.asset);
                    this.$forceUpdate();

                    if(articleAssets.length > 0) {

                        // prepare our articleAssetsArr (needed for the update into the assetsArticle table)
                        let articleAssetsArr = {
                            assets: [],
                            articles: []
                        }

                        articleAssets.forEach(function(articleAsset) {

                            if(articleAssetsArr.articles.indexOf(articleAsset.article) == -1) {
                                articleAssetsArr.articles.push(articleAsset.article);
                            }

                            if(articleAssetsArr.assets.indexOf(articleAsset.asset) == -1) {
                                articleAssetsArr.assets.push(articleAsset.asset);
                            }

                        })

                        // save in articleAssets
                        this.axios.put(this.$config.api + 'articleAsset/updateArticleReferences', articleAssetsArr)
                            .then((response) => {

                                // find and assign the response fields to our newly inserted assets
                                this.table.tblData.forEach((asset, index) => {

                                    if(articleAssetsArr.assets.indexOf(asset.id) > -1) {
                                      asset.articles = response.data.article;
                                    }

                                })


                                this.fetchData().then(() => {
                                  setTimeout(() => {
                                    this.closeModal();
                                  }, 1000)
                                })

                                /*
                                this.modalIsSaving = false;
                                this.showModal = false;
                                this.uploadedImages = [];
                                */

                            });

                    } else {

                      this.fetchData().then(() => {
                        setTimeout(() => {
                          this.closeModal();
                        }, 1000)
                      })

                    }


                })


        },


        massEditImagesDelete() {

            this.entityDelete('asset', this.markedRows, 'IP-MSG-CONFIRM_DELETION', false)
                .then((response) => {

                    this.markedRows.forEach((delRow) => {
                        this.table.tblData.forEach((row, index) => {
                            if(row.id == delRow) {
                                this.table.tblData.splice(index, 1);
                            }
                        });
                    })

                    this.markedRows = [];

                });

        },

        deleteImage(id) {

            // find the index of the clicked row first
      			var foundIndex = "";
      			this.table.tblData.forEach(function(row, index) {
      				if(row.id == id) {
      					foundIndex = index;
      				}
            })

      			// if we found an index, delete the category in the DB
      			// and remove it from the array
      			if(foundIndex > -1) {

      				var self = this;
      				this.entityDelete('asset', this.table.tblData[foundIndex].id, 'IP-MSG-CONFIRM_DELETION_SINGLE')
      					.then(function(response) {
      						self.table.tblData.splice(foundIndex, 1);
      					})

      			}

        },

        closeModal() {

            this.showModal = false;
            this.modalIsSaving = false;
            this.uploadedImages = [];
            this.selectedImages.origin = "";
            this.selectedImages.status = null;
            this.selectedImages.articles = [];

        },

        toggleAll() {

            this.markedRows = this.allMarked ? [] : this.$refs.tblImagePool.data.map(row => row.id);
            this.allMarked = !this.allMarked;

        },

    		search() {

    			var self = this;
          setTimeout(function() {
              Event.$emit('vue-tables.tblImagePool.filter::search', self.searchString );
          }, 10);

    		},

        dzSuccess(file) {

	        var result = JSON.parse(file.xhr.response);
          var self = this;

          let newImageObj = {
              filename: result.fileName,
              path: result.dir,
			        uploadFilename: file.name,
              createdBy: this.activeUser.id,
              status: this.assetStatus.DEFAULT
          }

          this.entityCreateOrUpdate('asset?include=asset.status', newImageObj, { isSilent: true })
              .then((response) => {

                  var d = new Date();
                  response.updated = d.toISOString();
                  response.articles = [];

                  // find our newly uploaded images and put them in our "uploadedImages" array
                  this.uploadedImages.push(response);
                  // this.table.tblData.push(response);

                  // remove the image from our dropzone after 1 sec
                  setTimeout(() => {
                      this.$refs.dzImagePool.$children[0].removeFile(file);
                  }, 1200);

              });

        },

    		getImagePath(asset, thumb=false) {

    			return this.$config.assets + asset.path + '/' + (thumb != false ? 'thumb/' : '') + asset.filename;

    		},

        uploadImages() {

            this.showModal = true;
            this.modal.isLoading = true;
            this.modal.title = 'Neue Bilder hochladen';
            this.modal.type = 'upload';
            this.modal.class = "modalUploadImages vcenter";

        },

        fetchData() {

            this.isLoading = true;
            var self = this;

      			// get articles
      			function getArticles() {
      				return self.axios.get(self.$config.api + 'article?loadChangesLog=0&fields=title&orderBy=created%20DESC');
      			}

      			// get assets
      			function getAssets() {
      				return self.axios.get(self.$config.api + 'asset/imagePool')
      			}

      			// make the request
      			return this.axios.all([getAssets(), getArticles()])
      				.then(self.axios.spread(function (assets, articles) {
      					self.table.tblData = assets.data.asset;
                self.table.tblData.forEach(function(e) {
                    e._thumb = { src: self.$config.assets + e.path + '/thumb/' + e.filename };
                });

                // console.log("data: ", self.table.tblData);

                self.articles = articles.data.article;
      					self.isLoading = false;
      				}));

        },


        save(isSilent=false) {

            //console.log("uploadedImages: ", this.uploadedImages);
            //console.log("table.tblData: ", this.table.tblData);

            return this.entityCreateOrUpdate('asset', this.uploadedImages, { isSilent: isSilent });
            // return this.entityCreateOrUpdate('asset', this.table.tblData, { isSilent: isSilent }).then((res) => { this.isSaving = false; });

        }

    }
}
</script>

<style lang="scss">
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    .p-default {
        margin: 0;
    }
</style>

<style scoped>

    .filters .control {
        margin-bottom: 0;
    }

    .popover .popover-title {
        font-size: 12px;
    }
    .popover .popover-content .small {
        font-size: 12px !important;
    }


    .has-text-light {
        color: #aaa;
    }
    .tbl-imagePool >>> td {
        position: relative;
    }
    .tbl-imagePool >>> td .options {
        position: absolute;
        bottom: 15px;
        font-size: 11px;
        opacity: 0;
        transition: opacity .5s ease-in-out;
    }

    /*
    .tbl-imagePool >>> td .options > span {
        display: inline-block;
        padding: 4px 6px;
        background: rgba(255,255,255,0.85);
    }
    */


    .tbl-imagePool >>> td .icon {
        font-size: 9px;
        line-height: 14px;
        height: 14px;
        width: 14px;
    }
    .tbl-imagePool >>> td:hover .options {
        zoom: 1;
        filter: alpha(opacity=0);
        opacity: 1;
    }


    .tbl-imagePool >>> th:first-child {
        width: 40px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 4px;
    }
    .tbl-imagePool >>> td:first-child {
        position: relative;
        width: 40px;
    }
    >>> .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
    .tbl-imagePool >>> th:nth-child(2) {
        width: 100px;
    }
    .tbl-imagePool >>> th:nth-last-child(2) {
        width: 140px;
    }
    .tbl-imagePool >>> th:last-child {
        width: 180px;
    }
    .tbl-imagePool >>> td:first-child {
        /*
        -webkit-box-shadow: inset 6px 0px 0px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: inset 6px 0px 0px 0px rgba(0,0,0,0.75);
        box-shadow: inset 6px 0px 0px 0px rgba(0,0,0,0.75);
        */
        margin: 0 auto;
        text-align: center;
    }
    .tbl-imagePool >>> .DEFAULT td:first-child {
        -webkit-box-shadow: inset 6px 0 0 0 #CDCDD2;
        -moz-box-shadow: inset 6px 0 0 0 #CDCDD2;
        box-shadow: inset 6px 0 0 0 #CDCDD2;
    }

    .tbl-imagePool >>> .APPROVED td:first-child {
        -webkit-box-shadow: inset 6px 0 0 0 #bfe29e;
        -moz-box-shadow: inset 6px 0 0 0 #bfe29e;
        box-shadow: inset 6px 0 0 0 #bfe29e;
    }

    .tbl-imagePool >>> td:nth-child(3) {
        white-space: normal;
    }
    /*
    .tbl-imagePool >>> td:nth-last-child(2) {
        text-align: center;
    }
    */

    >>> .imgWrapper {
		background-repeat: no-repeat;
	    background-position: 50% 50% !important;
	    background-size: contain;
	    width: 75px;
	    height: 55px;
	    margin: 0;
	    background-color: #FFF;
	    border: 1px solid #efefef;
	    border-radius: 3px;
	}
    >>> .imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}
    >>> .imgWrapper[lazy=error]  {
		background-image: none !important;
	}

    /* MODALS */

    /* MODAL upload images */
    .modalUploadImages >>> .modal-card {
        width: 100%;
        max-width: 720px;
    }
    .modalUploadImages >>> .modal-card .control,
    .modalUploadImages >>> .modal-card .control > .control {
        width: 100%;
        max-width: 100%;
    }

    .modalUploadImages .uploadedImagesContainer {
        max-height: 250px;
        overflow-y: auto;
    }
    .modalUploadImages .uploadedImages {
        margin: 10px 0;
        background-color: #f5f7f9 !important;
        border-radius: 2px;
        align-items: center;
        font-size: 12px;
    }
    .modalUploadImages .uploadedImages .column:first-child {
        max-width: 90px;
    }
    .modalUploadImages .uploadedImages .column:last-child {
        max-width: 40px;
    }
    .modalUploadImages .uploadedImages .imgWrapper {
        width: 65px;
        height: 45px;
    }

    /* MODAL edit images */
    .modalEditImages >>> .modal-card {
        width: 100%;
        max-width: 640px;
    }
</style>
